import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TextConditions from './TextConditions';
import AvisoPrivacidadMexico from './AvisoPrivacidadMexico';
import {
  selectPaisId,
  selectHeader,
} from 'legacyfrontend/redux/selectors/application-selectors';
import { ROUTE_KEYS } from 'legacyfrontend/constants';
import { Seo } from 'core/components/seo';
import { useAppName } from 'legacyfrontend/hooks/useSafeState';

export default function PrivacyPolicy() {
  const { t } = useTranslation(['layout']);
  const rawPaisId = useSelector(selectPaisId);
  const paisId = Number(rawPaisId) || 1;
  const appName = useAppName();

  if (paisId === 1) {
    return <Redirect to={ROUTE_KEYS.GENERAL_CONDITIONS} />;
  }

  const header = useSelector(selectHeader);
  const templateData = useSelector((state) => state.applicationState.templateData);
  const footer = templateData?.footer;
  const principalOffice = templateData?.principalOffice;

  const emailContacto = header?.emailContacto || principalOffice?.email;
  const webUrl = footer?.web;
  const razonSocial = footer?.razonSocial;
  const domicilio = principalOffice?.direccion;

  const getDetalleValor = (nombre) =>
    footer?.detalle?.find((d) => d.tipoEnlace?.nombre === nombre)?.valor;
  const arcoNombre =
    getDetalleValor('aviso-privacidad-arco-nombre') || principalOffice?.nombre;
  const arcoDomicilio =
    getDetalleValor('aviso-privacidad-arco-domicilio') || principalOffice?.direccion;
  const arcoEmail =
    getDetalleValor('aviso-privacidad-arco-email') || principalOffice?.email;
  const arcoTelefono =
    getDetalleValor('aviso-privacidad-arco-telefono') || principalOffice?.telefono;
  const fechaUltimaActualizacion = getDetalleValor('aviso-privacidad-fecha-actualizacion');

  // México: Aviso de Privacidad
  if (paisId === 4) {
    return (
      <>
        <Seo
          title={`${t('footer.privacyPolicy')} | ${appName}`}
          description={`${t('footer.privacyPolicy')} de ${appName}. Información sobre el tratamiento de datos personales y derechos ARCO.`}
        />
        <div className='pt-7 pb-10 py-5 container'>
        <div className='px-12 py-12 bg-white rounded-md'>
          <h1 className='text-2xl text-black font-bold text-center mb-8'>
            {t('footer.privacyPolicy')}
          </h1>
          <div className='text-sm text-gray-400 py-12'>
            <AvisoPrivacidadMexico
              emailContacto={emailContacto}
              webUrl={webUrl}
              razonSocial={razonSocial}
              domicilio={domicilio}
              arcoNombre={arcoNombre}
              arcoDomicilio={arcoDomicilio}
              arcoEmail={arcoEmail}
              arcoTelefono={arcoTelefono}
              fechaUltimaActualizacion={fechaUltimaActualizacion}
            />
          </div>
        </div>
      </div>
      </>
    );
  }

  // Perú (2) y Brasil (3): cada uno su propia política
  if (paisId !== 2 && paisId !== 3) {
    return null;
  }

  return (
    <>
      <Seo
        title={`${t('footer.privacyPolicy')} | ${appName}`}
        description={`${t('footer.privacyPolicy')} de ${appName}. Información sobre el tratamiento de datos personales y protección de la privacidad.`}
      />
      <div className='pt-7 pb-10 py-5 container'>
        <div className='px-12 py-12 bg-white rounded-md'>
          <h1 className='text-2xl text-black font-bold text-center mb-8'>
            {t('footer.privacyPolicy')}
          </h1>
          <div className='text-sm text-gray-400 py-12'>
            <TextConditions paisId={paisId} />
          </div>
        </div>
      </div>
    </>
  );
}
